import { createStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import miusuario from '../redux/reducers/miusuario'
import pais from '../redux/reducers/pais'
import idioma from '../redux/reducers/idioma'
import modo from '../redux/reducers/modo'
import esquema_actual from '../redux/reducers/esquema'
import esquema_tablas from '../redux/reducers/esquema_tablas'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import interfaz from '../redux/reducers/interfaz'

const thunkMiddleware = require('redux-thunk').default

const rootReducer = combineReducers({
    miusuario,
    interfaz,
    pais,
    esquema_tablas,
    idioma,
    modo,
    esquema_actual,
})

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
 
export default () => {
  let store = createStore(persistedReducer, applyMiddleware(thunkMiddleware))
  let persistor = persistStore(store)
  return { store, persistor }
}